import React, { useState, useRef, useEffect } from "react";
import { DoubleArrow } from "@mui/icons-material";
import * as Mui from "@mui/material";
import { TableEmptyState } from "components/CustomComponents/EmptyState";

import {
  parentBoxStyle,
  scrollTop,
  tableRowSize,
  stickyHeader,
} from "services/constants";

import { Box, Typography, Paper } from "@mui/material";
import { doubleArrowStyle } from "services/constants";

export const EmployeeDetails = ({ onClose, empData }) => {
  const [page, setPage] = useState(0);
  const containerRef = useRef(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [rowsPerPage, setRowsPerPage] = useState(25);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const employeeHeader = [
    {
      name: "Name",
      key: "name",
    },
    {
      name: "Employee ID",
      key: "employee_id",
    },
    {
      name: "Dept",
      key: "department",
    },
    {
      name: "Date",
      key: "date",
    },
  ];

  return (
    <>
      <Box sx={parentBoxStyle}>
        <Paper elevation={0} sx={{ borderRadius: 0 }}>
          <Box>
            <Box sx={{ pl: 0.5 }}>
              <Mui.IconButton onClick={onClose} sx={doubleArrowStyle}>
                <DoubleArrow />
              </Mui.IconButton>
            </Box>
            <Box sx={{ ml: 2, mb: 0.5 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Report
              </Typography>
            </Box>
          </Box>
        </Paper>
        <Box sx={{ ml: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 17 }}>
            {empData?.event_type}
          </Typography>
        </Box>

        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          <Box>
            <Mui.TableContainer
              ref={containerRef}
              sx={{
                maxHeight: 700,
                overflow: "auto",
              }}
            >
              <Mui.Table className="border" sx={{ minWidth: "100%" }}>
                <Mui.TableHead sx={stickyHeader}>
                  <Mui.TableRow sx={tableRowSize}>
                    {employeeHeader?.map((value, index) => (
                      <Mui.TableCell key={index} sx={tableRowSize}>
                        {value?.name}
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {empData?.logs?.Boxlength === 0 ? (
                    <TableEmptyState dataLength={empData?.logs} />
                  ) : (
                    empData?.logs
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      ?.map((value, rowIndex) => (
                        <Mui.TableRow key={rowIndex} sx={tableRowSize}>
                          {employeeHeader.map((head, cellIndex) => (
                            <Mui.TableCell key={cellIndex}>
                              {value[head.key] ?? "N/A"}
                            </Mui.TableCell>
                          ))}
                        </Mui.TableRow>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
              {empData?.logs?.length > 25 && (
                <Mui.TablePagination
                  className="custom-pagination"
                  component="div"
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  count={empData?.logs?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}
            </Mui.TableContainer>
          </Box>
        </Box>
      </Box>
    </>
  );
};
